import config from '@/config';
import api from '@/shared/api';
import { useEffect, useState } from 'react';
var useGetRelation = function (relationId) {
    var _a = useState(), relation = _a[0], setRelation = _a[1];
    useEffect(function () {
        var isMounted = true;
        api.base
            .post("".concat(config.appUrls.api, "/api/relation/Names"), [relationId])
            .then(function (_a) {
            var rel = _a.data[0];
            if (rel && isMounted) {
                setRelation(rel);
            }
        });
        return function () {
            isMounted = false;
        };
    }, [relationId]);
    return relation;
};
export default useGetRelation;
